import * as swcHelpers from '@swc/helpers';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { createResponsiveImage } from '../../ProductBlock/utils/get-variant-images.js';

const convertProductRecommendationInfo = (recommendation, formatProductUrl, locale)=>{
    var ref, ref1, ref2, ref3, ref4;
    if (!CommerceToolsApi.isProductTypeName(recommendation.productType)) {
        console.error(`Recommendation has invalid product type name "${recommendation.productType}"`);
        return;
    }
    const images = recommendation.images.reduce((m, image)=>!image.label || !image.dimension ? m : [
            ...m,
            {
                url: image.url,
                label: image.label,
                dimensions: {
                    w: image.dimension.width,
                    h: image.dimension.height
                }
            }, 
        ]
    , []);
    const hasFrontImage = Boolean(images[0]);
    const hasAngleImage = Boolean(images[1]);
    var ref5;
    const front = hasFrontImage ? createResponsiveImage((ref = images[0]) === null || ref === void 0 ? void 0 : ref.url, (ref5 = (ref1 = images[0]) === null || ref1 === void 0 ? void 0 : ref1.label) !== null && ref5 !== void 0 ? ref5 : undefined) : undefined;
    var ref6;
    const angle = hasAngleImage ? createResponsiveImage((ref2 = images[1]) === null || ref2 === void 0 ? void 0 : ref2.url, (ref6 = (ref3 = images[1]) === null || ref3 === void 0 ? void 0 : ref3.label) !== null && ref6 !== void 0 ? ref6 : undefined) : undefined;
    return swcHelpers.objectSpread({
        sku: recommendation.sku,
        brand: recommendation.brand,
        url: formatProductUrl({
            slug: {
                [locale]: recommendation.slug
            },
            sku: recommendation.sku,
            productType: recommendation.productType
        }),
        images: {
            front,
            angle
        },
        productType: recommendation.productType,
        name: recommendation.name || recommendation.brandModel || '',
        price: recommendation.price.value.centAmount,
        discountedPrice: (ref4 = recommendation.price.discounted) === null || ref4 === void 0 ? void 0 : ref4.value.centAmount,
        tags: recommendation.tags
    }, recommendation.promotionLabel ? {
        promotionLabel: recommendation.promotionLabel
    } : {});
};
const convertBannerRecommendationInfo = (recommendation)=>{
    const responsiveImage = createResponsiveImage(recommendation.image.url, recommendation.title);
    var _action;
    return {
        title: recommendation.title,
        description: recommendation.description,
        image: {
            url: responsiveImage.url,
            mobileUrl: responsiveImage.url,
            description: recommendation.description
        },
        action: (_action = recommendation.action) !== null && _action !== void 0 ? _action : undefined
    };
};

export { convertBannerRecommendationInfo, convertProductRecommendationInfo };
//# sourceMappingURL=mappers.js.map
